import script from "./MobileSidemenuButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileSidemenuButton.vue?vue&type=script&setup=true&lang=ts"

import "./MobileSidemenuButton.vue?vue&type=style&index=0&id=2487e8a2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2487e8a2"]])

export default __exports__